<script setup lang="ts">
import { RouterView } from 'vue-router';
import { VApp } from 'vuetify/components';
import LogoutModal from '@/components/LogoutModal.vue';
</script>

<template>
    <v-app>
        <LogoutModal />
        <RouterView />
    </v-app>
</template>

<style lang="scss">
.v-application {
    background-color: rgb(var(--v-theme-neutral-99));
}
</style>
